import { Checkbox } from "@/components/ui/checkbox";

// "Never ends" toggle for repeat rules: the series keeps running until it is deleted.
export const NeverEnds = ({ rec, setRec, testid }) => (
  <label className="flex items-center gap-2 cursor-pointer">
    <Checkbox checked={!!rec.forever} onCheckedChange={(v) => setRec({ ...rec, forever: !!v })} data-testid={testid} />
    <span className="text-sm text-slate-700">Never ends <span className="text-slate-400">(runs until deleted)</span></span>
  </label>
);
